import { CustomLightProps } from '../domain/ChosenCustomProduct.interface';
import { ChosenOption } from '../domain/ChosenOption.interface';
import { Equipment } from '../domain/Equipment.interface';
import { Finish } from '../domain/Finish.interface';
import { Model } from '../domain/Model.interface';
import {Option, OptionLight} from '../domain/Option.interface';
import { Project } from '../domain/Project.interface';

export type SelectedOptions = { qty: number; option: Option|OptionLight }[];

export enum TunnelVersion {
  R1 = 'r1',
  KIT = 'kit',
  QUOTE = 'quote',
  UPSELL = 'upsell',
}

export interface CurrentNegativeDefaultOptionModel {
  option: Option | ChosenOption;
  quantity: number;
}

export interface CurrentNegativeDefaultOptionFinishEquipment {
  option: Option | ChosenOption;
  quantity: number;
}

export interface TunnelConfiguration {
  quantity: number;
  currentSurface: number;
  currentModel: Model | null;
  currentFinish: Finish | null;
  currentEquipment: Equipment | null;
  currentOptions: SelectedOptions;
  currentCustomProduct: CustomLightProps[];
  currentNegativeDefaultOptionModel: CurrentNegativeDefaultOptionModel[];
  currentNegativeDefaultOptionFinishEquipment: CurrentNegativeDefaultOptionFinishEquipment[];
}

export interface TunnelState {
  version: TunnelVersion;
  currentProject: Project | null;
  haveBeenTouched: boolean;
  errorModalIsOpen: boolean;
  missingWindowColorModalIsOpen: boolean;
  lastPersistStatus: string;
  currentConfigIndex: number;
  configurations: TunnelConfiguration[];
}
